import {makeStyles} from "@material-ui/core";

export default function ProtocolosListaCss() {
    return makeStyles(theme => ({
        root: {
            marginTop: 20
        },
    }));
}